import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FormActionEvent } from 'src/app/shared/components';
import { ConfirmPopup, InformationPopup, Popup, PopupType, WarningPopup } from 'src/app/shared/models';
import { TranslationService } from './translation.service';
import { ClickEvent } from 'devextreme/ui/button';

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  public popup = new Subject<Popup>();
  constructor(public translationService: TranslationService) { }

  private formatText(text: any): string {
    if (text == null) return '';
    if (typeof text === 'string') return text;
    try { return JSON.stringify(text); } catch { return String(text); }
  }

  close(){
    this.popup.next({
      visible: false
    })
  }

  confirm(popup: ConfirmPopup){
    this.popup.next({...popup, visible: true, type: PopupType.Confirm});
  }

  inform(popup: InformationPopup){
    this.popup.next({...popup, visible: true, type: PopupType.Information});
  }

  warning(popup: WarningPopup){
    this.popup.next({...popup, visible: true, type: PopupType.Warning});
  }

  public showPopup = (event: FormActionEvent | ClickEvent, text: any) =>{
    const displayText = this.formatText(text);
    this.inform({
      message: this.translationService.translate("popup_message_row_selection", displayText, displayText),
      visible: true,
      onOkClicked: () => {
        this.close();
      },
    title: this.translationService.translate('popup_title_row_selection'),
    });
  }

  public showWarningPopup = (event: ClickEvent | any, text: any) =>{
    const displayText = this.formatText(text);
    this.warning({
      message: this.translationService.translate("popup_message_configure", displayText),
      visible: true,
      onOkClicked: () => {
        this.close();
      },
    title: this.translationService.translate('popup_title_warning'),
    });
  }

  public showPrintPopup = (text: any, onYesClick: Function, onNoClick: Function) => {
    const displayText = this.formatText(text);
    this.confirm({
      message: displayText,
      visible: true,
      onYesClicked: () => {
        this.close();
        onYesClick && onYesClick();
      },
      onNoClicked: () => {
        this.close();
        onNoClick && onNoClick();
      },
    title: this.translationService.translate('popup_title_print_current'),
    });
  }

  public showAcceptPopup = (text: any, onOkClick: Function) => {
    const displayText = this.formatText(text);
    this.warning({
      message: displayText,
      visible: true,
      onOkClicked: () => {
        this.close();
      },
    title: this.translationService.translate('popup_title_accept_quotation'),
    });
  }

  public confirmationPopup = (text: any, onYesClick: Function, onNoClick: Function) => {
    const displayText = this.formatText(text);
    this.confirm({
      message: displayText,
      visible: true,
      onYesClicked: () => {
        this.close();
        onYesClick && onYesClick();
      },
      onNoClicked: () => {
        this.close();
        onNoClick && onNoClick();
      },
    title: this.translationService.translate('popup_title_print_current'),
    });
  }

}
